import { render } from "./ClubPhilosophy.vue?vue&type=template&id=39adbe96&scoped=true"
import script from "./ClubPhilosophy.vue?vue&type=script&lang=js"
export * from "./ClubPhilosophy.vue?vue&type=script&lang=js"

import "./ClubPhilosophy.vue?vue&type=style&index=0&id=39adbe96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39adbe96"]])

export default __exports__